import React from "react";
import styles from "./LoadingPlaceholder.module.css";

const LoadingPlaceholder = () => (
  <div className={`${styles.placeholder} ${styles.shimmer}`}></div>
);

export default LoadingPlaceholder;
